import { CodeBase } from "./_codeBase";

/**
 * 機能コード
 * 
 * ※一旦必要なものだけ用意します。
 * 
 */
export class FuncitonCode extends CodeBase<FuncitonCode>
{
    /** 機能コード: F_04_APPR_002, "予定表（カスタマイズ）" */
    public static readonly F_04_APPR_002: FuncitonCode = new FuncitonCode("F_04_APPR_002", "予定表（カスタマイズ）");
    /** 機能コード: F_04_APPR_003, "予定承認表" */
    public static readonly F_04_APPR_003: FuncitonCode = new FuncitonCode("F_04_APPR_003", "予定承認表");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): FuncitonCode[] {
        return [
            FuncitonCode.F_04_APPR_002,
            FuncitonCode.F_04_APPR_003,
        ];
    }
}
